<template>
  <button-base-style class="button">
    <a
      :href="href"
      class="button__item">
      <span
        v-if="icon"
        class="button__icon">
        <icon-font
          :name="icon"
          class="button__icon-font"/>
      </span>
      <span class="button__title">{{ title }}</span>
    </a>
  </button-base-style>
</template>

<script>

import { adminToolBarLink } from '@/mikan/_shared/types/vueTypes/adminToolBarLink';
import ButtonBaseStyle from '@/mikan/_shared/components/atoms/ButtonBaseStyle.vue';
import IconFont from '@/mikan/_shared/components/atoms/icons/IconFont.vue';
import AnchorLink from '@/mikan/_shared/components/atoms/AnchorLink.vue';

export default {
  components: {
    ButtonBaseStyle,
    IconFont,
    AnchorLink,
  },
  props: {
    href: adminToolBarLink.href,
    icon: adminToolBarLink.icon,
    title: adminToolBarLink.title,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.button {
  border: 0;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    transition: color $transition-base;
  }

  &__icon {
    flex: 0 0 auto;
  }

  &__icon-font {
    color: $color-orange;
    font-size: 1em;
  }

  &__title {
    flex: 1 0 auto;

    &:nth-child(n + 2) {
      margin-left: 0.5em;
    }
  }
}
</style>
